import { CalculatorCourse } from './SemesterCalculator';
import { gradeValues } from './CalculatorTypes';

export const getValidCourses = (courses: CalculatorCourse[]): CalculatorCourse[] => {
  return courses.filter((course) => course.grade > 0);
};

export const calculateAverageGrade = (courses: CalculatorCourse[]): number => {
  const validCourses = getValidCourses(courses);
  if (validCourses.length === 0) {
    return 0;
  }

  const totalPoints = validCourses.reduce((sum, course) => sum + course.coursePoint, 0);
  if (totalPoints <= 0) {
    return 0;
  }

  const productSum = validCourses.reduce((sum, course) => {
    return sum + course.grade * course.coursePoint;
  }, 0);

  return Math.round((productSum / totalPoints) * 10) / 10;
};

export const getLetterGrade = (averageGrade: number): string => {
  return Object.keys(gradeValues).find((key) => gradeValues[key] === Math.round(averageGrade)) || 'F';
};
